import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Localization from 'expo-localization';
import resources from '@/features/i18n/resources';

let i18nInstance: typeof i18n | null = null;

export const initI18n = () => {
  if (i18nInstance) {
    return i18nInstance;
  }

  void i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: Localization.getLocales()[0].languageTag,
    ns: Object.keys(resources.en),
    defaultNS: 'common',
    resources,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['asyncStorage', 'navigator'],
      caches: ['asyncStorage'],
      lookupAsyncStorage: AsyncStorage.getItem,
      asyncStorage: AsyncStorage,
    },
  });

  i18nInstance = i18n;
  return i18n;
};
